
import Auth from './auth.store';

export default {
  Auth,
};
